import { EinstellungenFormContext } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/EinstellungenFormContext';
import { useEinstellungenForm } from '@/domain/controlling/pages/Umsatzplanung/Einstellungen/Forms/EinstellungenForm/useEinstellungenForm';
import { ReactNode } from 'react';

export function EinstellungenFormProvider({
  children,
}: {
  children: ReactNode;
}) {
  const form = useEinstellungenForm();
  return (
    <EinstellungenFormContext.Provider value={form}>
      {children}
    </EinstellungenFormContext.Provider>
  );
}
